const lang = {
    ja: {
        'registerViewer.register': '入場申込み登録（フォーム入力）',
        'registerViewer.workPlace': '※{workPlace}なき場合は「個人」と入力して下さい',
        'registerViewer.exampleNumber': '記入例：225-0001 → 2250001 と入力',
        'registerViewer.exampleTel': '記入例：045-912-2112 → 0459122112 と入力',
        'registerViewer.exampleTelTwo': '記入例：045-912-2181 → 0459122181 と入力',
        'registerViewer.jpEnTranslateHelp':'日本語を入力してカーソルを移動すると英文に自動翻訳します。',
        'registerViewer.typeAgain': 'もう一度入力してください',
        'registerViewer.termService': '利用規約',
        'registerViewer.accept': '同意します',
        'registerViewer.benefitRegistration': '登録のメリット',
        'registerViewer.textNote': '申込みの{textExhibit}への入場、{textSeminar}への参加、{textLivestream}イベントへの参加ができます',
        'registerViewer.searchExhibition': '展示情報を探せます（サイト検索機能）',
        'registerViewer.material': '資料のダウンロードや資料請求ができます。',
        'registerViewer.contactPersonCharge': '担当者とコンタクトできます。',
        'registerViewer.noteSuggestRegisterViewer': 'フォームに入力、送信後、入力頂いた{email}宛に入場アカウントを送信します。',
        'registerViewer.applicationCompleted': '申し込み完了',
        'registerViewer.suggestRegisterViewer': 'お申し込みを正常に受付けました。管理者より入場方法に関する通知メールを送信しましたので申し込み時のEメールをご確認ください。',
        'registerViewer.exhibitionAdmissionApplication': '展示会入場申込み',
        'registerViewer.applicationSeminar': 'セミナー受講申込',
        'registerViewer.applicationLivestream': 'ライブ配信視聴申込み',
        'registerViewer.age': '年齢',
        'registerViewer.other': 'その他',
        'registerViewer.purposeSeminar': 'セミナー受講目的',
    },
    en: {
        'registerViewer.register': 'Registration for entry (form entry)',
        'registerViewer.workPlace': '*If you don’t enter your {workPlace}, please apply as a “private” attendee.',
        'registerViewer.exampleNumber': 'Example: 225-0001 --> 2250001 (without hyphen (-)).',
        'registerViewer.exampleTel': 'Example: 045-912-2112 --> 0459122112 (without hyphen (-)).',
        'registerViewer.exampleTelTwo': 'Example: 045-912-2181 --> 0459122181 (without hyphen (-)).',
        'registerViewer.jpEnTranslateHelp':'Enter in Japanese and move the cursor, and then automatically translate to English',
        'registerViewer.typeAgain': 'Please enter again.',
        'registerViewer.termService': 'Terms of Use',
        'registerViewer.accept': 'I Agree',
        'registerViewer.benefitRegistration': 'Benefits of registration',
        'registerViewer.textNote': 'You can enter an {textExhibit} you have applied for and participate in a {textSeminar} and {textLivestream} event.',
        'registerViewer.searchExhibition': 'You can search for exhibition information (Site search feature).',
        'registerViewer.material': 'You can download or request materials.',
        'registerViewer.contactPersonCharge': 'You can contact a person in charge. ',
        'registerViewer.noteSuggestRegisterViewer': 'After the form is filled out and submitted, your account information for entry is sent to the {email} you entered.',
        'registerViewer.applicationCompleted': 'Application completed',
        'registerViewer.suggestRegisterViewer': 'We accepted your application. The administrator sent you an email informing how to enter. Please check you mailbox.',
        'registerViewer.exhibitionAdmissionApplication': 'Application for exhibition entry',
        'registerViewer.applicationSeminar': 'Application for attending a seminar',
        'registerViewer.applicationLivestream': 'Application for watching a live streaming',
        'registerViewer.age': 'Age',
        'registerViewer.other': 'Others',
        'registerViewer.purposeSeminar': 'Purpose for attending the seminar',
    },
};

export default lang;
